import { map } from 'lodash';
import { v4 as uuid } from 'uuid';
import { toUUID } from '../../util/transform';
import type { ITicketRealEstate } from './TicketRealEstate.interface';
import TicketLoanPropertySplit from './TicketLoanPropertySplit';
import TicketTitleDetail from './TicketTitleDetail';
import TicketLoanFee from './TicketLoanFee';

export default class TicketRealEstate implements ITicketRealEstate {
  id: string;
  dealRealEstatePropertySplit: Array<TicketLoanPropertySplit>;
  titleDetails: Array<TicketTitleDetail>;
  fees: Array<TicketLoanFee>;

  static build = (data: ITicketRealEstate) => new TicketRealEstate(data);
  static blank = () => new TicketRealEstate({ id: uuid() });

  /**
   * Constructor
   * @param {ITicketRealEstate} data
   */
  constructor(data?: ITicketRealEstate) {
    this.id = toUUID(data?.id) || uuid();
    this.dealRealEstatePropertySplit = map(
      data?.dealRealEstatePropertySplit,
      (obj) => new TicketLoanPropertySplit(obj)
    );
    this.titleDetails = map(data?.titleDetails, (obj) => new TicketTitleDetail(obj));
    this.fees = map(data?.fees, (obj) => new TicketLoanFee(obj));
  }
}
